<template>
  <v-app id="inspire">
    <v-app-bar
      app
      color="green darken-4"
      dark
    >
      <v-toolbar-title>Crew Saver</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn-toggle
        v-model="ruleset"
        color="white"
        group
      >
        <v-btn value="NCAA" @click="changeRuleset('NCAA')">NCAA</v-btn>
        <v-btn value="NFHS" @click="changeRuleset('NFHS')">NFHS</v-btn>
      </v-btn-toggle>
      <v-spacer></v-spacer>
      <v-btn icon @click="showAbout = !showAbout">
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      <v-btn v-if="!user.name" icon @click="login">
        <v-icon>mdi-football-helmet</v-icon>
      </v-btn>
      <v-toolbar-title v-if="user.name">{{ user.name }}</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row v-if="showAbout">
          <About></About>
        </v-row>
        <v-row align="center" justify="center">
          <v-col>
            <QuestionCard 
              @nextQuestion="randomQuestion"
              :question="question" 
              :user="user"
              v-if="atQuestions.length > 0 "></QuestionCard>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <FNSAd />
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import About from "./components/About.vue"
import QuestionCard from "./components/QuestionCard.vue";
import FNSAd from "./components/FNSAd.vue"
import axios from "axios";
import firebase from "firebase";

const airTableApp = 'appoK9YXu6s8xQ4rq';
const airTableName = 'Questions';

export default {
  name: "App",
  data: () => ({
    question: {},
    atQuestions: [],
    questionSet: [],
    user: {
      name: '',
      rightQuestions: [],
      wrongQuestions: []
    },
    ruleset: 'NCAA',
    showAbout: false
  }),
  mounted() {
    this.loadQuestions();
  },
  methods: {
    login() {
      const provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().signInWithPopup(provider).then((result) => {
        this.$router.replace('Home');
        console.dir(result);
        this.user.name = result.additionalUserInfo.profile.given_name;
      }).catch((err) => {
        console.log('Error: ' + err.message)
      });
    },
    shuffle(arr) {
      let counter = arr.length;
      let temp;
      let index;

      while (counter > 0) {
        index = Math.floor(Math.random() * counter);
        counter--;
        temp = arr[counter];
        arr[counter] = arr[index];
        arr[index] = temp;
      }
      return arr;
    },
    handleCorrectness(questionID, questionAnsweredCorrectly) {
//make sure the same question isn't in rightAnswers and wrongAnswers
      if (questionAnsweredCorrectly) {
        const wrongIndex = this.user.wrongQuestions.indexOf(questionID)
        if (wrongIndex >= 0) {
          this.user.wrongQuestions.splice(wrongIndex, 1)
        }
        const rightIndex = this.user.rightQuestions.indexOf(questionID)
        if (rightIndex < 0) {
          this.user.rightQuestions.push(questionID)
        }
      } else if (questionAnsweredCorrectly != undefined && !questionAnsweredCorrectly) {
        const rightIndex = this.user.rightQuestions.indexOf(questionID)
        if (rightIndex >= 0) {
          this.user.rightQuestions.splice(rightIndex, 1)
        }
        const wrongIndex = this.user.wrongQuestions.indexOf(questionID)
        if (wrongIndex < 0) {
          this.user.wrongQuestions.push(questionID)
        }
      }
//wipe the previous question from the set and then re-add based on right/wrong
      let newQuestionSet = this.questionSet.filter(el => el.id != questionID);
      this.questionSet = newQuestionSet;
      this.questionSet.push(this.question);
      if (!questionAnsweredCorrectly) {
        this.questionSet.push(this.question);
      }
    },
    randomQuestion(questionID, questionAnsweredCorrectly) {
      this.showAbout = false;
      if (questionAnsweredCorrectly != undefined) {
        this.handleCorrectness(questionID, questionAnsweredCorrectly);
      }
      this.question = this.questionSet[Math.floor(Math.random() * this.questionSet.length)];
      this.question.answers= this.shuffle([this.question.CorrectChoice, 
                        this.question.WrongChoice1,
                        this.question.WrongChoice2]);
    },
    loadQuestions() {
      this.atQuestions = [];
      axios.get(`https://api.airtable.com/v0/${airTableApp}/${airTableName}`,
        { headers: { Authorization: "Bearer " + process.env.VUE_APP_AIRTABLE_API_TOKEN }})
      .then((response) => {
        this.atQuestions = response.data.records
        .map((item)=>{
          return {
            id: item.id,
            ...item.fields
          }
        })
      })
      .catch((error) => {
          console.log(error)
      })
      .then(() => {
        this.filterRuleset(this.ruleset);
        this.prepareQuestionSet();
        this.randomQuestion();
      })
    },
    filterRuleset(ruleset = 'NCAA') {
      this.questionSet = this.atQuestions
        .filter(question => question.Ruleset == ruleset);
    },
    prepareQuestionSet() {
      this.questionSet.forEach(question => {
        if (this.user.wrongQuestions.includes(question.id)) {
          this.questionSet.push(question);
        } else {
          this.questionSet.push(question);
          this.questionSet.push(question);
        }
      })
    },
    changeRuleset(ruleset) {
      this.filterRuleset(ruleset);
      this.prepareQuestionSet();
      this.randomQuestion();
    }
  },
  components: {
    QuestionCard,
    FNSAd,
    About
  }
};
</script>

<style scoped>
</style>
